'use client'

import { useState } from 'react'
import { useUnitContext } from '@/hooks/useUnitContext'
import { ToggleButton } from '@desoutter/uikit'

export default function ToggleUnit() {
	const { unit, dispatch } = useUnitContext()
	const [state, setState] = useState<string>(unit)

	const onChange = (value: string) => {
		setState(value)
		dispatch({ unit: value })
	}

	const units = [
		{
			label: 'Metric',
			value: 'Metric',
		},
		{
			label: 'Imperial',
			value: 'Imperial',
		},
	]
	return <ToggleButton options={units} value={state} onChange={onChange} />
}
